"use strict";

module.exports = /* @ngInject */ function(openFinApi) {
  (function() {
    console.log("Publishing mfa-successful to OpenFin");
    openFinApi.publish("mfa-successful");
    close();
  })();

  function close() {
    if (openFinApi.isInOpenFin) {
      openFinApi.getFin().then(fin => {
        var force = true;
        fin.desktop.Window.getCurrent().close(force);
      });
    } else {
      window.document.body.innerHTML =
        "Windows cannot be closed in browsers other than OpenFin - please close this window manually.";
    }
  }
};



// WEBPACK FOOTER //
// ./app/presentation/controllers/MultiFactorAuthenticationController.js